import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Panel, Empty } from "@/components/terminal";
import { BookOpen } from "lucide-react";

const CAT_CLS = {
  TRADE: "border-l-emerald-600", RISK: "border-l-red-600", INFLOW: "border-l-blue-500",
  CONFIG: "border-l-amber-500", PROPOSAL: "border-l-slate-500", INFO: "border-l-slate-600",
};

export default function Journal() {
  const [entries, setEntries] = useState(null);
  useEffect(() => { api.get("/journal").then((r) => setEntries(r.data)).catch(() => {}); }, []);
  if (!entries) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="journal-page">
      <h2 className="font-display text-xl font-bold">Decision Journal</h2>
      <p className="text-xs text-slate-500">Why did Hussar Treasury do this? Every action explained in plain language.</p>
      <Panel title="Journal" testId="decision-journal-timeline">
        {entries.length === 0 ? <Empty>No journal entries yet.</Empty> : (
          <div className="space-y-3">
            {entries.map((e) => (
              <div key={e.id} className={`border-l-2 ${CAT_CLS[e.category] || CAT_CLS.INFO} bg-[#121316] rounded-r-sm px-4 py-3`} data-testid={`journal-entry-${e.id.slice(0, 8)}`}>
                <div className="flex items-center gap-3 text-[10px] tracking-widest uppercase text-slate-500 mb-1">
                  <span className="font-mono">{new Date(e.timestamp).toLocaleString()}</span>
                  <span className="text-slate-600">·</span><span>{e.category}</span>
                </div>
                <p className="text-sm text-slate-200 leading-relaxed">{e.summary}</p>
              </div>
            ))}
          </div>
        )}
      </Panel>
    </div>
  );
}
